import styled from 'styled-components';

export const StyledPPECard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .ppe-card {
    width: 276px;
    height: 236px;
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    &-item {
      position: absolute;
      max-width: 56px;
      width: 56px;
      overflow: hidden;
      text-align: center;
      z-index: 2;

      > span {
        font-size: 8px;
      }

      &.HELMET {
        top: 46px;
      }

      &.GOGGLES {
        top: 46px;
        right: -1px;
      }

      &.VEST {
        top: 132px;
      }

      &.HARNESS {
        right: -1px;
        top: 132px;
      }

      &.GLOVE {
        top: 219px;
      }

      &.SHOES {
        top: 219px;
        right: -1px;
      }
    }
  }

  > img {
    width: 356px;
    height: 254px;
    object-fit: contain;
  }
`;
